module.exports = __webpack_public_path__ + "static/media/youtu_player.8cfddc57.png";